
export const FILE_ATTACHMENT_PREFIX = 'jlinc:dm:attachment:'
